var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRenew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9728 11.4375C18.3038 14.9776 15.509 18 12 18C10.3932 18 8.93408 17.3634 7.85625 16.3312L9.53981 14.6478C9.89411 14.2934 9.64316 13.6875 9.14201 13.6875H4.125C3.81435 13.6875 3.5625 13.9394 3.5625 14.25V19.267C3.5625 19.7682 4.16839 20.0191 4.52269 19.6648L6.13219 18.0552C7.65154 19.5288 9.72124 20.4375 12 20.4375C16.8338 20.4375 20.7414 16.3472 20.4166 11.4375H17.9728ZM19.4773 4.33526L17.8678 5.9448C16.3485 4.47124 14.2788 3.5625 12 3.5625C7.16621 3.5625 3.25856 7.65281 3.58339 12.5625H6.02719C5.69621 9.02235 8.49105 6 12 6C13.6068 6 15.0659 6.63664 16.1437 7.66875L14.4602 9.35224C14.1059 9.70661 14.3568 10.3125 14.858 10.3125H19.875C20.1857 10.3125 20.4375 10.0606 20.4375 9.75V4.73299C20.4375 4.23187 19.8316 3.98089 19.4773 4.33526Z",
    fill: "#0000C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenew);
export default __webpack_public_path__ + "static/media/renew.b9b6f7748b3b96ace94ce73a57a8b497.svg";
export { ForwardRef as ReactComponent };